import React, { useContext } from "react";
import Bread from "../../common/Bread";
import { BsTelephoneForwardFill, BsFillPhoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { LangContext } from "../../context/LangContext";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import AxiosClass from "../../common/AxiosClass";
import Loader from "../../common/Loader";
import { getImageAlt } from "../../utils/imageAlt";
import "./branchwiseOfficers.scss";

const BranchwiseOfficers = () => {
  const { slug } = useParams();
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  // Title based on slug + language
  const title = (() => {
    switch (slug) {
      case "grievance":
        return nep ? "गुनासो अधिकारीहरू" : "Grievance Officers";
      case "information":
        return nep
          ? "शाखा अनुसार गुनासो र सूचना अधिकारी"
          : "Branchwise Grievance and Information Officers";
      default:
        return nep ? "अधिकारीहरू" : "Officers";
    }
  })();

  const breadcrumList = {
    image: "",
    title,
    l1: nep ? "होम" : "Home",
    l2: nep ? "अधिकारीहरू" : "Officers",
    l3: "",
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["branchOfficers", slug],
    queryFn: () =>
      AxiosClass.getApi(`/officers/${slug}`).then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;
  if (error) return "An error has occurred: " + error.message;
  // console.log(data);
  return (
    <Bread data={breadcrumList}>
      {slug === "grievance" ? (
        <div className="officers-grid-container" tabIndex={0} role="region" aria-label={nep ? "गुनासो अधिकारीहरू" : "Grievance Officers"}>
          {data.items?.map((i) => (
            <div key={i.id} className="officer" tabIndex={0} role="region" aria-label={nep ? i.name_nepali : i.name}>
              <div className="branch">
                <h3 tabIndex={0}>{i.branch}</h3>
              </div>
              <div className="paper">
                <div className="detail-container">
                  <img src={i.featured_image} alt={getImageAlt(i, nep ? i.name_nepali : i.name)} />
                  <p className="officer-name" tabIndex={0}>{nep ? i.name_nepali : i.name}</p>
                  <div>
                    <MdEmail />
                    <p tabIndex={0}>{i.email}</p>
                  </div>
                  <div>
                    <BsTelephoneForwardFill />
                    <p tabIndex={0}>{i.contact}</p>
                  </div>
                  <div>
                    <BsFillPhoneFill />
                    <p tabIndex={0}>{i.mobile}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <Tabs className="officersPageTabContainer" tabIndex={0} role="region" aria-label={title}>
          <TabList className="officersPageTabsButtonContainer">
            <Tab key={0} className="officersPageTabButton">
              {nep ? "काठमाडौँ उपत्यका भित्र" : "Inside Kathmandu Valley"}
            </Tab>
            <Tab key={1} className="officersPageTabButton">
              {nep ? "उपत्यका बाहिर" : "Outside Valley"}
            </Tab>
          </TabList>

          <TabPanel key={0}>
            <div className="officers-grid-container" tabIndex={0} role="region" aria-label={nep ? "काठमाडौँ उपत्यका भित्र" : "Inside Kathmandu Valley"}>
              {data.items
                ?.filter((obj) => obj.valley === "Inside")
                .map((i) => (
                  <div key={i.id} className="officer" tabIndex={0} role="region" aria-label={nep ? i.name_nepali : i.name}>
                    <div className="branch">
                      <h3 tabIndex={0}>{i.branch}</h3>
                    </div>
                    <div className="paper">
                      <div className="detail-container">
                        <img src={i.featured_image} alt={getImageAlt(i, nep ? i.name_nepali : i.name)} />
                        <p className="officer-name" tabIndex={0}>
                          {nep ? i.name_nepali : i.name}
                        </p>
                        <div>
                          <MdEmail />
                          <p tabIndex={0}>{i.email}</p>
                        </div>
                        <div>
                          <BsTelephoneForwardFill />
                          <p tabIndex={0}>{i.contact}</p>
                        </div>
                        <div>
                          <BsFillPhoneFill />
                          <p tabIndex={0}>{i.mobile}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </TabPanel>

          <TabPanel key={1}>
            <div className="officers-grid-container" tabIndex={0} role="region" aria-label={nep ? "उपत्यका बाहिर" : "Outside Valley"}>
              {data.items
                ?.filter((obj) => obj.valley === "Outside")
                .map((i) => (
                  <div key={i.id} className="officer" tabIndex={0} role="region" aria-label={nep ? i.name_nepali : i.name}>
                    <div className="branch">
                      <h3 tabIndex={0}>{i.branch}</h3>
                    </div>
                    <div className="paper">
                      <div className="detail-container">
                        <img src={i.featured_image} alt={getImageAlt(i, nep ? i.name_nepali : i.name)} />
                        <p className="officer-name" tabIndex={0}>
                          {nep ? i.name_nepali : i.name}
                        </p>
                        <div>
                          <MdEmail />
                          <p tabIndex={0}>{i.email}</p>
                        </div>
                        <div>
                          <BsTelephoneForwardFill />
                          <p tabIndex={0}>{i.contact}</p>
                        </div>
                        <div>
                          <BsFillPhoneFill />
                          <p tabIndex={0}>{i.mobile}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </TabPanel>
        </Tabs>
      )}
    </Bread>
  );
};

export default BranchwiseOfficers;
